import { IconButton, IconButtonProps, useTheme } from "@mui/material";
import { ElementType, ReactNode } from "react";
import { Tooltip } from "../tooltip/Tooltip";

interface CircularIconButtonProps extends Omit<IconButtonProps, "children"> {
  icon: ReactNode;
  tooltip?: string;
  size?: "small" | "medium" | "large";
}

const sizeMap = {
  small: "32px",
  medium: "40px",
  large: "48px",
};

export const CircularIconButton = ({
  icon,
  tooltip,
  size = "medium",
  onClick,
  sx,
  ...rest
}: CircularIconButtonProps) => {
  const theme = useTheme();

  const button = (
    <IconButton
      onClick={onClick}
      aria-label={tooltip || "icon button"}
      sx={{
        width: sizeMap[size],
        height: sizeMap[size],
        borderRadius: "100%",
        boxShadow: "0px 0px 4px 0px #00000029, 0px 0px 2px 0px #00000014",
        border: `1px solid ${theme.palette.neutral["010"]}`,
        justifyContent: "center",
        alignItems: "center",
        bgcolor: theme.palette.common.white,
        color: theme.palette.lightBg.high,
        "&:hover": {
          bgcolor: theme.palette.neutral["005"],
        },
        ...sx,
      }}
      {...rest}
    >
      {icon}
    </IconButton>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
};
